
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


import User from 'components/user'
import Project from 'components/project'
import Github from 'components/github'
import Show from 'components/show'
export default {
    components: {
        Show,
        User,
        Project,
        Github,
        Tabbar,
        TabbarItem,
        Group,
        Cell
    },
    data() {
        return {
            choose_user: false,
            choose_project: false,
            choose_github: false,
            choose_show: true
        }
    },
    methods: {
        ChooseUser: function(idx) {
            console.log(idx)
            this.choose_user = false
            this.choose_project = false
            this.choose_github = false
            this.choose_show = false

            if (idx == 0)
                this.choose_show = true
            else if (idx == 1)
                this.choose_user = true
            else if (idx == 2)
                this.choose_project = true
            else if (idx == 3)
                this.choose_github = true
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/resume.vue